import React, { useContext, useState } from "react";
import { Alert, Button, Col, Form, FormControl, Row } from "react-bootstrap";
import ContextComponent from "../../Context";

const CommentForm = props => {
  const context = useContext(ContextComponent);
  const [comment_body, set_comment_body] = useState("");
  const [comment_name, set_comment_name] = useState(
    context.profile
      ? context.profile.first_name + " " + context.profile.last_name
      : "",
  );
  const [comment_email, set_comment_email] = useState(
    context.profile && context.profile.email ? context.profile.email : "",
  );
  const [requesting, set_requesting] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const fieldId = `comment-${props.post_id}-${props.comment_id || "new"}`;

  const sendComment = () => {
    if (props.disabled || requesting) return;
    set_requesting(true);
    setFeedback(null);
    context.ApiDriver.postComment(
      {
        body: comment_body,
        post_id: props.post_id,
        fullname: comment_name,
        email: comment_email,
        reply_to: props.comment_id,
      },
      () => {
        context.notification("نظر شما با موفقیت ثبت شد .", "success");
        setFeedback({ type: "success", message: "نظر شما با موفقیت ثبت شد." });
        set_comment_body("");
        set_comment_name("");
        set_comment_email("");
        if (props.modalClose) props.modalClose();
        else if (context.modal && typeof context.modal.hide === "function")
          context.modal.hide();
        set_requesting(false);
      },
      () => {
        context.notification("مشکلی در ارسال بوجود آمد.", "error");
        setFeedback({
          type: "danger",
          message: "ارسال نظر انجام نشد. لطفاً دوباره تلاش کنید.",
        });
        set_requesting(false);
      },
    );
  };

  return (
    <>
      <h2>{props.form_title}</h2>
      <hr />
      {feedback && (
        <Alert
          variant={feedback.type}
          role={feedback.type === "success" ? "status" : "alert"}>
          {feedback.message}
        </Alert>
      )}
      <Row className="mx-0">
        <Col md={6}>
          <Form.Group>
            <Form.Label htmlFor={`${fieldId}-email`}>ایمیل:</Form.Label>
            <Form.Control
              id={`${fieldId}-email`}
              type="email"
              disabled={props.disabled}
              value={comment_email}
              onChange={e => {
                set_comment_email(e.target.value);
              }}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label htmlFor={`${fieldId}-fullname`}>نام:</Form.Label>
            <Form.Control
              id={`${fieldId}-fullname`}
              type="text"
              disabled={props.disabled}
              value={comment_name}
              onChange={e => {
                set_comment_name(e.target.value);
              }}
            />
          </Form.Group>
        </Col>
      </Row>
      <div className="px-3">
        <Form.Group>
          <Form.Label htmlFor={`${fieldId}-body`}>نظر</Form.Label>
          <FormControl
            id={`${fieldId}-body`}
            as="textarea"
            disabled={props.disabled}
            value={comment_body}
            onChange={e => {
              set_comment_body(e.target.value);
            }}
          />
        </Form.Group>
      </div>
      <hr />
      <div className="d-flex justify-content-end">
        <Button
          variant="secondary"
          type="button"
          disabled={requesting || props.disabled}
          onClick={sendComment}>
          {requesting ? "..." : "ارسال"}
        </Button>
      </div>
    </>
  );
};

export default CommentForm;
